import "./App.css";
import { Admin, Resource, CustomRoutes } from "react-admin";
import { Route, Navigate } from "react-router-dom";
// mui icon
import PersonIcon from "@mui/icons-material/Person";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CasinoIcon from "@mui/icons-material/Casino";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import VideogameAssetIcon from "@mui/icons-material/VideogameAsset";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import HistoryIcon from "@mui/icons-material/History";
import TollIcon from "@mui/icons-material/Toll";
import CampaignIcon from "@mui/icons-material/Campaign";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
// pages
import LoginPage from "./Views/SignIn/forms/LoginPage";
import SignUp from "./Views/SignIn/forms/SignUp";
import PasswordResetEmail from "./Views/SignIn/forms/PasswordResetEmail";
import ResetPassword from "./Views/SignIn/forms/ResetPassword";
import EmailSent from "./Views/SignIn/EmailSent";
import NewCreateGameRTP from "./Views/GameRTP/forms/NewCreateGameRTP";
import NewEditGameRTP from "./Views/GameRTP/forms/NewEditGameRTP";
import CreateWheelSpin from "./Views/WheelSpin/forms/CreateWheelSpin";
import EditWheelSpin from "./Views/WheelSpin/forms/EditWheelSpin";

// provider
import { authProvider } from "./Provider/parseAuthProvider";
import { dataProvider } from "./Provider/parseDataProvider";
// theme
import { MyLayout } from "./Layout/MyLayout";
import { MyTheme } from "./Layout/MyDefaultTheme";
// components
import { GameRecordList } from "./Views/GameRecords/GameRecords";
import { RedeemList } from "./Views/RedeemRecords/RedeemList";
import { RechargeList } from "./Views/RechargeRecords/RechargeList";
import { UserList } from "./Views/UserList/UserList";
import { GameCoinsList } from "./Views/GameCoins/GameCoinsList";
import { DayCoinsList } from "./Views/DayCoins/DayCoinsList";
import { GameWiseUserData } from "./Views/GameCoins/Table/GameWiseUserData";
import { UserHierarchy } from "./Views/UserList/forms/UserHierarchy";
import { Dashboard } from "./Views/Dashboard/Dashboard";
import { Profile } from "./Views/Profile/Profile";
import { GameRTP } from "./Views/GameRTP/GameRTP";
import { WheelSpin } from "./Views/WheelSpin/WheelSpin";
import { WheelSpinHistoryList } from "./Views/WheelSpinHistory/WheelSpinHistoryList";
import { HourlyBonusHistoryList } from "./Views/HourlyBonusHistory/HourlyBonusHistoryList";
import { Reports } from "./Views/Reports/Reports";
import { AccountsList } from "./Views/Accounts/AccountsListNew";
import { AllGamesUserData } from "./Views/GameCoins/Table/AllGamesUserData";
import LeaderboardIcon from "@mui/icons-material/Leaderboard"; // best fit
import { GamesData } from "./Views/GameCoins/Table/GamesData";
import { AgentAccountList } from "./Views/Accounts/AgentAccountList";
import { TransactionList } from "./Views/TransactionCoin/TransactionList";
import { GamePromotion } from "./Views/GamePromotion/GamePromotion";
import RechargeWidgetPage from "./Widget";
import { CLKKWidgetCard } from "./Widget/CLKKWidgetCard";
import ClkkCashout from "./Widget/ClkkCashout";
import { UserStatusHistoryList } from "./Views/UserList/UserStatusHistoryList";
import { Marketing } from "./Views/Marketing/Marketing";
import TransactionReports from "./Views/Reports/TransactionReports";
import { AgentReport } from "./Views/Reports/AgentReport";
import { SpinValidationList as SpinValidationReport } from "./Views/SpinValidation/SpinValidationList";
import { ManagementTree } from "./Views/ManagementTree/ManagementTree";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import TicketsList from "./Views/Tickets/TicketsList";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import TicketReport from "./Views/Reports/TicketReport";
import { HourlyBonusWheel } from "./Views/HourlyBonusWheel/HourlyBonusWheel";
import { HouseTreasury } from "./Views/HouseTreasury/HouseTreasury";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { CreateHourlyBonusWheel } from "./Views/HourlyBonusWheel/forms/CreateHourlyBonusWheel";
import { EditHourlyBonusWheel } from "./Views/HourlyBonusWheel/forms/EditHourlyBonusWheel";
import { useEffect } from "react";
import { initializeWebSocket } from "./Provider/socket";

function App() {
  // Initialize socket globally for messaging
  useEffect(() => {
    initializeWebSocket((event, data) => {
      // Global socket event handler
      console.log("Socket event:", event, data);
    });
  }, []);

  return (
    <Admin
      dataProvider={dataProvider}
      authProvider={authProvider}
      loginPage={LoginPage}
      layout={MyLayout}
      theme={MyTheme}
    >
      {/* {(permissions) =>
        permissions ? (
          <>
            <Resource
              name="users"
              list={UserList}
              options={{ label: "User List" }}
              icon={PersonIcon}
            />
            <Resource
              name="redeemRecords"
              list={RedeemList}
              options={{ label: "Redeem Records" }}
              icon={CreditCardIcon}
            />
            <Resource
              name="rechargeRecords"
              list={RechargeList}
              options={{ label: "Recharge Records" }}
              icon={CreditCardIcon}
            />
            <Resource
              name="profile"
              list={Profile}
              options={{ label: "Profile" }}
              icon={PersonOutlineOutlinedIcon}
            />
            {permissions && permissions === "Super-User" && (
              <>
                <Resource
                  name="dashboard"
                  list={Dashboard}
                  options={{ label: "Dashboard" }}
                  icon={DashboardOutlinedIcon}
                />
                <Resource
                  name="gameCoins"
                  list={GameCoinsList}
                  options={{ label: "Game Coins" }}
                  icon={TollIcon}
                />
                <Resource
                  name="dayWiseCoins"
                  list={DayCoinsList}
                  options={{ label: "Daily Coins" }}
                  icon={TollIcon}
                />
                <Resource
                  name="GameCatalogue"
                  list={GameRecordList}
                  options={{ label: "Game Records" }}
                  icon={CasinoIcon}
                />
                <Resource
                  name="GameRtp"
                  list={GameRTP}
                  options={{ label: "GameRTP" }}
                  icon={VideogameAssetIcon}
                />
                <Resource
                  name="SpinningWheel"
                  list={WheelSpin}
                  options={{ label: "Wheel Spin" }}
                  icon={SportsSoccerIcon}
                />
              </>
            )}
          </>
        ) : (
          <CustomRoutes noLayout>
            <Route path="*" element={<Navigate to="/login" replace />} />
            <Route path="/login" element={<LoginPage />} />
          </CustomRoutes>
        )
      } */}

      {(permissions) => {
        if (permissions && permissions === "Super-User") {
          return (
            <>
              <Resource
                name="dashboard"
                list={Dashboard}
                options={{ label: "Dashboard" }}
                icon={DashboardOutlinedIcon}
              />
              <Resource
                name="users"
                list={UserList}
                options={{ label: "User List" }}
                icon={PersonIcon}
              />
              <Resource
                name="redeemRecords"
                list={RedeemList}
                options={{ label: "Redeem Records" }}
                icon={CreditCardIcon}
              />
              <Resource
                name="rechargeRecords"
                list={RechargeList}
                options={{ label: "Recharge Records" }}
                icon={CreditCardIcon}
              />
              <Resource
                name="gameCoins"
                list={GameCoinsList}
                options={{ label: "Game Coins" }}
                icon={TollIcon}
              />
              <Resource
                name="dayWiseCoins"
                list={DayCoinsList}
                options={{ label: "Daily Coins" }}
                icon={TollIcon}
              />
              <Resource
                name="accounts"
                list={AccountsList}
                options={{ label: "Total Accounts" }}
                icon={DescriptionOutlinedIcon}
              />

              <Resource
                name="GameCatalogue"
                list={GameRecordList}
                options={{ label: "Game Records" }}
                icon={CasinoIcon}
              />
              <Resource
                name="GameRtp"
                list={GameRTP}
                options={{ label: "GameRTP" }}
                icon={VideogameAssetIcon}
              />
              <Resource
                name="gamePromotion"
                list={GamePromotion}
                options={{ label: "Game Promotion" }}
                icon={CampaignIcon}
              />
              <Resource
                name="SpinningWheel"
                list={WheelSpin}
                options={{ label: "Wheel Spin" }}
                icon={SportsSoccerIcon}
              />
              <Resource
                name="HourlyBonusWheel"
                list={HourlyBonusWheel}
                options={{ label: "Hourly Bonus" }}
                icon={SportsSoccerIcon}
              />
              <Resource
                name="hourlyBonusHistory"
                list={HourlyBonusHistoryList}
                options={{ label: "Hourly Bonus History" }}
                icon={HistoryIcon}
              />
              <Resource
                name="wheelSpinHistory"
                list={WheelSpinHistoryList}
                options={{ label: "Wheel Spin History" }}
                icon={HistoryIcon}
              />
                <Resource
                name="houseTreasury"
                list={HouseTreasury}
                options={{ label: "House Treasury" }}
                icon={AccountBalanceIcon}
              />
              <Resource
                name="allGamesUserDataV2"
                list={AllGamesUserData}
                options={{ label: "All Games Data" }}
                icon={LeaderboardIcon}
              />
              <Resource
                name="transactionReports"
                list={TransactionReports}
                options={{ label: "Transaction Reports" }}
                icon={DescriptionOutlinedIcon}
              />
              <Resource
                name="agentReport"
                list={AgentReport}
                options={{ label: "Agent Report" }}
                icon={DescriptionOutlinedIcon}
              />
              <Resource
                name="spinValidationReport"
                list={SpinValidationReport}
                options={{ label: "Spin Validation Report" }}
                icon={DescriptionOutlinedIcon}
              />
              <Resource
                name="profile"
                list={Profile}
                options={{ label: "Profile" }}
                icon={PersonOutlineOutlinedIcon}
              />
              <Resource
                name="marketing"
                list={Marketing}
                options={{ label: "Marketing" }}
                icon={FolderSharedIcon}
              />
              <Resource
                name="managementTree"
                list={ManagementTree}
                options={{ label: "Management Tree" }}
                icon={AccountTreeIcon}
                />
              <Resource
                name="tickets"
                list={TicketsList}
                options={{ label: "Support Tickets" }}
                icon={ConfirmationNumberIcon}
              />
              <Resource
                name="ticketReport"
                list={TicketReport}
                options={{ label: "Ticket Report" }}
                icon={DescriptionOutlinedIcon}
              />
            </>
          );
        } else if (
          (permissions && permissions === "Game-Owner") ||
          (permissions && permissions === "Master-Distributor") ||
          (permissions && permissions === "Distributor") ||
          (permissions && permissions === "Sub-Distributor")
        ) {
          return (
            <>
              <Resource
                name="users"
                list={UserList}
                options={{ label: "User List" }}
                icon={PersonIcon}
              />
              <Resource
                name="redeemRecords"
                list={RedeemList}
                options={{ label: "Redeem Records" }}
                icon={CreditCardIcon}
              />
              <Resource
                name="rechargeRecords"
                list={RechargeList}
                options={{ label: "Recharge Records" }}
                icon={CreditCardIcon}
              />
              <Resource
                name="gameCoins"
                list={GameCoinsList}
                options={{ label: "Game Coins" }}
                icon={TollIcon}
              />
              <Resource
                name="dayWiseCoins"
                list={DayCoinsList}
                options={{ label: "Daily Coins" }}
                icon={TollIcon}
              />
              <Resource
                name="accounts"
                list={AccountsList}
                options={{ label: "Total Accounts" }}
                icon={DescriptionOutlinedIcon}
              />
              <Resource
                name="reports"
                list={Reports}
                options={{ label: "Reports" }}
                icon={DescriptionOutlinedIcon}
              />
              <Resource
                name="transactionReports"
                list={TransactionReports}
                options={{ label: "Transaction Reports" }}
                icon={DescriptionOutlinedIcon}
              />
              <Resource
                name="profile"
                list={Profile}
                options={{ label: "Profile" }}
                icon={PersonOutlineOutlinedIcon}
              />
              <Resource
                name="marketing"
                list={Marketing}
                options={{ label: "Marketing" }}
                icon={FolderSharedIcon}
              />
              <Resource
                name="managementTree"
                list={ManagementTree}
                options={{ label: "Management Tree" }}
                icon={AccountTreeIcon}
              />
            </>
          );
        } else if (permissions && permissions === "Agent") {
          return (
            <>
              <Resource
                name="users"
                list={UserList}
                options={{ label: "User List" }}
                icon={PersonIcon}
              />
              <Resource
                name="redeemRecords"
                list={RedeemList}
                options={{ label: "Redeem Records" }}
                icon={CreditCardIcon}
              />
              <Resource
                name="rechargeRecords"
                list={RechargeList}
                options={{ label: "Recharge Records" }}
                icon={CreditCardIcon}
              />
              <Resource
                name="gameCoins"
                list={GameCoinsList}
                options={{ label: "Game Coins" }}
                icon={TollIcon}
              />
              <Resource
                name="dayWiseCoins"
                list={DayCoinsList}
                options={{ label: "Daily Coins" }}
                icon={TollIcon}
              />

              <Resource
                name="reports"
                list={Reports}
                options={{ label: "Reports" }}
                icon={DescriptionOutlinedIcon}
              />
              <Resource
                name="transactionReports"
                list={TransactionReports}
                options={{ label: "Transaction Reports" }}
                icon={DescriptionOutlinedIcon}
              />
              <Resource
                name="profile"
                list={Profile}
                options={{ label: "Profile" }}
                icon={PersonOutlineOutlinedIcon}
              />
              <Resource
                name="marketing"
                list={Marketing}
                options={{ label: "Marketing" }}
                icon={FolderSharedIcon}
              />
              <Resource
                name="managementTree"
                list={ManagementTree}
                options={{ label: "Management Tree" }}
                icon={AccountTreeIcon}
              />
            </>
          );
        } else {
          return (
            <CustomRoutes noLayout>
              <Route path="*" element={<Navigate to="/login" replace />} />
              <Route path="/login" element={<LoginPage />} />
            </CustomRoutes>
          );
        }
      }}

      <CustomRoutes>
        <Route path="/creategamertp" element={<NewCreateGameRTP />} />
        <Route path="/editgamertp" element={<NewEditGameRTP />} />
        <Route path="/users/:id" element={<UserHierarchy />} />
        {/* <Route path="/users/:userId" element={<Wining />} /> */}
        <Route path="/createwheelspin" element={<CreateWheelSpin />} />
        <Route path="/editwheelspin" element={<EditWheelSpin />} />
        <Route path="/createhourlybonuswheel" element={<CreateHourlyBonusWheel />} />
        <Route path="/edithourlybonuswheel" element={<EditHourlyBonusWheel />} />
        <Route path="/gameCoins/:id" element={<GameWiseUserData />} />
        <Route path="/user-details/:id" element={<GamesData />} />
        <Route path="/agent-account" element={<AgentAccountList />} />
        <Route path="/transactions" element={<TransactionList />} />
        <Route path="/user-status-history/:id" element={<UserStatusHistoryList />} />
      </CustomRoutes>

      <CustomRoutes noLayout>
        <Route path="/signup" element={<SignUp />} />
        <Route path="/reset-email-sent" element={<EmailSent />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/reset-email" element={<PasswordResetEmail />} />
        <Route path="/widget" element={<RechargeWidgetPage />} />
        <Route path="/clk-card" element={<CLKKWidgetCard />} />
        <Route path="/clkk-cashout" element={<ClkkCashout />} />

      </CustomRoutes>
    </Admin>
  );
}

export default App;
